import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";

export default function* financialStatementDownload(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.PAGE_FINANCIAL_STATEMENT_DOWNLOAD_REQUEST
    });

    const res = yield call(Http.get, `charges/${action?.payload?.chargeId}/invoice?language=${action?.payload?.language}`);

    yield put({
      type: Constants.PAGE_FINANCIAL_STATEMENT_DOWNLOAD_SUCCESS
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, res?.data?.url);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.PAGE_FINANCIAL_STATEMENT_DOWNLOAD_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchFinancialStatementDownload() {
  yield takeEvery(Constants.PAGE_FINANCIAL_STATEMENT_DOWNLOAD_START, financialStatementDownload);
}
